import styled from 'styled-components'

export const CenterContent = styled.div`
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
`